import { TRuleSources } from 'meta/rule_sources'

const rule_sources = {
  BATTLETOME_OSSIARCH_BONEREAPERS: {
    name: 'Battletome: Ossiarch Bonereapers',
    type: 'battletome',
  },
} satisfies TRuleSources

export default rule_sources
